module.exports = __webpack_public_path__ + "img/vertical_4_7_4.68cb5bbf.png";